import React, { useEffect, useState } from 'react';
import "./App.css";
import { Link, useNavigate } from 'react-router-dom';
import logoECJ from "./img/ecj-logo.svg";
import { BACKEND_URL } from "./config";

export default function Gracias() {

  const userId = localStorage.getItem("user_id") || "No disponible";
  const navigate = useNavigate();
  const [emissionsKg, setEmissionsKg] = useState(null);
  const [loadingEmissions, setLoadingEmissions] = useState(false);

  useEffect(() => {
    sessionStorage.clear();
    window.scrollTo(0, 0);
    const cached = localStorage.getItem("emissions_kg_co2e");
    if (cached) {
      setEmissionsKg(Number(cached));
    } else if (userId && userId !== "No disponible") {
      setLoadingEmissions(true);
      fetch(`${BACKEND_URL}/emissions/${encodeURIComponent(userId)}`)
        .then(r => (r.ok ? r.json() : Promise.reject()))
        .then(d => {
          if (typeof d?.emissions_kg_co2e === "number") {
            setEmissionsKg(d.emissions_kg_co2e);
            localStorage.setItem("emissions_kg_co2e", String(d.emissions_kg_co2e));
          }
        })
        .catch(() => {/* opcional: log */})
        .finally(() => setLoadingEmissions(false));
    }

  }, []);

  const btnBackToHome = () => {
    navigate('/');
  };
  
  return (
    <div className='thanks'>
      <div>
        <img
          className='logoECJ'
          src={logoECJ}
          alt="EconoJournal"
        />
        <h1>¡Gracias por sumarte!</h1>
        <h3>Tu inscripción está confirmada.</h3>
        <h4>Gracias por completar tus datos para generar eventos más sustentables.</h4>
      </div>

      <div className='sectionUserId'>
        <h3>Código de registro:</h3>
        <h1 className='idUser'>#{userId}</h1>
      </div>
      <div className="sectionEmissions">
        <h3>Tus emisiones:</h3>
        <h2 className='idUser'>
          {loadingEmissions
            ? "Calculando..."
            : emissionsKg != null
              ? `${emissionsKg.toLocaleString("es-AR", { maximumFractionDigits: 2 })} kg CO₂e`
              : "0"}
        </h2>
      </div>

      <h3>Medir es el primer paso para mejorar.</h3>

      <button type="button" onClick={btnBackToHome}>Volver al inicio</button>

      <div className='card'>
        <p><b>Recordá:</b></p>
        <p>Econojournal emite <b>Factura B</b> por defecto. Si requerís <b>Factura A</b>, te pedimos que la solicites vía email apenas concretes la compra: <Link onClick={() => window.location = 'mailto:administracion@econojournal.com.ar'}>administracion@econojournal.com.ar</Link> <b>Por favor realizá el pedido antes del 15/12/2025 indicando CUIT y razón social.</b></p>
      </div>
    </div>
  );
}
